import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { useAxiosInterviewExit } from "../axios";

export const useDeleteCandidateInterviewExit = () => {
  const [state, execute, cancel] = useAxiosInterviewExit<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId) =>
      execute({
        url: `/candidates/${candidateId}/interviews-exit/draft`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
